import NumberInputPage from "@components/NumberInputPage"

export default function Age() {
  return <NumberInputPage translationKey="age" placeholder="30" />
}
